module.exports = __webpack_public_path__ + "static-portal/img/nygl1.284917e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nygl1.png
// module id = kv0n
// module chunks = 4